export default __webpack_public_path__ + "static/media/background-card-menu-black.e98e88e4.svg";